module.exports = __webpack_public_path__ + "static/media/color-consistency.b6a4b88b.svg";